var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCountCard',{attrs:{"value":_vm.jobsStats.jobsApplicationsTotalCount,"unit":"متقدم لفرصة عمل "}})}
var staticRenderFns = []

export { render, staticRenderFns }